// @flow

import type { CountryCode } from '../types/country-code'
import { COUNTRY_CODE_NLD } from '../types/country-code'

export type Address = {
  street: ?string,
  houseNumber: ?number,
  houseNumberExtension: ?string,
  postalCode: ?string,
  city: ?string,
  countryCode: ?CountryCode
}

const buildAddress = function (): Address {
  return {
    street: null,
    houseNumber: null,
    houseNumberExtension: null,
    postalCode: '',
    city: '',
    countryCode: COUNTRY_CODE_NLD
  }
}

export {
  buildAddress
}



// WEBPACK FOOTER //
// ./src/types/address.js